import { css } from 'lit';

export const cardStyles = css`
  :host {
    display: block;
    box-sizing: border-box;
    padding: 0 var(--card-x-padding, var(--xs-spacer));
    margin-bottom: var(--card-margin-bottom, 0);

    min-width: var(--card-width, 100%);
    max-width: var(--card-width, 100%);
  }

  .card {
    position: relative;
    padding: 0;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    height: 100%;
    width: 100%;
    text-align: left;
    text-decoration: none;
    color: var(--uui-color-text);
    transition: box-shadow ease-in-out 0.3s, background-color 120ms, color 120ms,
      border-color 120ms;
    border-radius: 22px;
    border: 1px solid var(--color-border);
    box-sizing: border-box;

    --color-version-item-surface: var(--uui-color-surface);
    --color-long-description-gradient-from: var(--color-card-surface);
  }

  .card:hover {
    background: var(--color-card-surface);
    color: var(--uui-color-text);
  }

  .card.single {
    border: none;
    background: var(--uui-color-surface);
    border-bottom-left-radius: var(--border-bottom-radius, 22px);
    border-bottom-right-radius: var(--border-bottom-radius, 22px);

    --color-version-item-surface: var(--color-card-surface);
  }

  .card.single:hover {
    cursor: default;
  }

  .card:not(.single):hover {
    color: var(--uui-color-current-contrast);
    border-color: var(--uui-color-default);
    background-color: rgba(255, 255, 255, 0.2);
    box-shadow: var(--box-shadow-blue);
    --color-long-description-gradient-from: rgba(255, 255, 255, 0.2);
  }

  .card-body {
    padding: var(--s-spacer);
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    box-sizing: border-box;
  }

  .single .card-body {
    padding: var(--m-spacer);
  }

  @media (min-width: 767px) {
    .single .card-body {
      padding: var(--xl-spacer);
    }
  }

  .card-footer {
    display: flex;
    justify-content: space-between;
    margin-top: auto;
    position: relative;
  }

  .card-footer .badge:first-of-type {
    margin-left: auto;
  }

  h2,
  h3 {
    margin: 0;
    color: inherit;
    word-break: break-word;
  }

  h2 {
    font-size: 42px;
    line-height: normal;
  }

  h3 {
    font-size: 20px;
    line-height: normal;
  }

  .dinkus {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;
    gap: var(--s-spacer);
    max-width: 100%;
  }

  .card.single .dinkus {
    flex-direction: column;
    justify-content: flex-start;
    flex: none;

    h2 {
      font-size:36px;
      text-align: center;
      word-break: keep-all;
    }

    @media (min-width:600px) {
      flex-direction: row;

      h2 {
        font-size: 44px;
        word-break: unset;
        text-align: left;
      }
    }
  }

  .image-wrapper {
    display: flex;
    box-sizing: border-box;
    align-items: center;
    width: 80px;
    height: 80px;
    flex-shrink: 0;
    justify-content: center;
    border-radius: var(--xs-spacer);
    background-color: white;
    transition: background-color ease-in-out 0.3s;
  }

  img {
    display: block;
    margin: 0 auto;
    border-radius: 3px;
  }

  p {
    font-size: 20px;
    margin: var(--s-spacer) 0;
    word-break: break-word;
    max-width: 75ch;
  }

  :host([deck]) p {
    font-size: 16px;
    margin: var(--s-spacer) 0;
  }

  small {
    margin-top: auto;
    margin-bottom: var(--s-spacer);
    font-size: 12px;
    line-height: var(--m-spacer);
  }

  h3 + small {
    margin-top: var(--m-spacer);
  }

  .long {
    position: relative;
    height: 100px;
    overflow: hidden;
  }

  .long::after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: var(--xl-spacer);
    box-shadow: inset 0 -20px 20px -10px
      var(--color-long-description-gradient-from);
    transition: all ease-in-out 0.3s;
  }
`;
